// extracted by mini-css-extract-plugin
module.exports = {"separator":"Separator_separator__3-g4I","inset":"Separator_inset__ncQKW"};